<template>
  <div class="app-container">
    <el-card class="box-card">
      <div class="filter-container">
        <el-form :model="query" ref="queryForm" :inline="true">
          <el-form-item label="直播编号：">
            <el-input v-model="query.liveCode" placeholder="请输入直播编号" clearable size="small" />
          </el-form-item>
          <el-form-item label="直播主题：">
            <el-input v-model="query.title" placeholder="请输入直播主题" clearable size="small" />
          </el-form-item>
          <el-form-item label="主播手机号：">
            <el-input v-model="query.anchorPhone" placeholder="请输入手机号" clearable size="small" />
          </el-form-item>
          <el-form-item label="直播身份：">
            <el-select v-model="query.anchorPosition" placeholder="全部" clearable size="small">
              <el-option label="总监" value="总监"></el-option>
              <el-option label="营销经理" value="营销经理"></el-option>
              <el-option label="大区经理" value="大区经理"></el-option>
              <el-option label="地区经理" value="地区经理"></el-option>
              <el-option label="县区经理" value="县区经理"></el-option>
              <el-option label="研修班" value="研修班"></el-option>
              <el-option label="体验班" value="体验班"></el-option>
              <el-option label="普通人员" value="普通人员"></el-option>
              <el-option label="技术总监" value="技术总监"></el-option>
              <el-option label="督导" value="督导"></el-option>
              <el-option label="技术老师" value="技术老师"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="直播类型：">
            <el-select v-model="query.liveType" placeholder="全部" clearable size="small">
              <el-option label="全部" :value="undefined"></el-option>
              <el-option label="带货竖屏直播" :value="1"></el-option>
              <el-option label="培训横屏直播" :value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handleQuery" size="mini">搜索</el-button>
            <el-button type="info" @click="handleFilter" plain size="mini">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <el-card class="box-card mt10">
      <div class="btn-right-side mb10">
        <div class="btn-box">
          <!-- <el-button type="primary" size="mini" @click="handleExport" plain>导出</el-button> -->
          <el-button type="primary" size="mini" @click="handleCreate" icon="el-icon-plus">创建直播预告</el-button>
          <!-- <el-button type="danger" size="mini" @click="handleDeleteBatch" plain>批量删除</el-button> -->
        </div>
      </div>
      <el-table v-loading="listLoading" :data="list" @selection-change="selectionChange" @sort-change="sortChange">
        <el-table-column label="直播间" prop="livePO.id" align="center" fixed="left"   :formatter="LiveTitleFormatter" />
        <el-table-column label="主播姓名" prop="userPO.realName" align="center" fixed="left" />
        <el-table-column label="主播身份" prop="liveAnchorPO.position" align="center" />
        <el-table-column label="主播手机号" prop="userPO.userPho" align="center" />
        <el-table-column label="直播类型" prop="liveType" align="center">
          <template slot-scope="{row}">
            {{ row.livePO.liveType === 1 ? '带货竖屏直播' : row.livePO.liveType === 2 ? '培训横屏直播' : '-' }}
          </template>
        </el-table-column>
        <el-table-column label="直播主图" prop="liveImg" align="center">
          <template slot-scope="{row}">
            <el-image style="width: 50px; height: 50px" :src="row.livePO.liveImg" :preview-src-list="[row.livePO.liveImg]"></el-image>
          </template>
        </el-table-column>
        <el-table-column label="虚拟观看人数" prop="livePO.lookUserVirtualcount" align="center" />
        <!-- <el-table-column label="推流链接" prop="streamUrl" align="center">
          <template slot-scope="{row}">
            <div style="display: flex; align-items: center; justify-content: center;">
              <span style="margin-right: 8px; max-width: 200px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">{{ row.livePO.pushRtmpUri }}</span>
              <el-button type="text" @click="copyStreamUrl(row.livePO.pushRtmpUri)">复制</el-button>
            </div>
          </template>
        </el-table-column> -->
        <el-table-column label="创建时间" prop="livePO.createdTime" align="center" />
        <el-table-column label="开播时间" prop="livePO.startTime" align="center" />
        <el-table-column label="管理员人数" prop="livePO.adminCount" align="center">
          <template slot-scope="{row}">
            <span v-if="row.livePO.liveAdminPOList && row.livePO.liveAdminPOList.length > 0" 
                  style="color: #60B7DC; cursor: pointer;" 
                  @click="handleShowAdmins(row)">
              {{ row.livePO.liveAdminPOList.length }}
            </span>
            <span v-else>0</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="180" fixed="right">
          <template slot-scope="{row}">
            <el-button type="text" @click="handleLiveCancel(row)">取消预告</el-button>
            <el-button type="text" @click="handleLiveGoods(row)">直播商品</el-button>
            <!-- <el-button type="text" @click="handleLuckyBag(row)">直播福袋</el-button> -->
            <!-- <el-button type="text" @click="handleRecharge(row)">充值活动</el-button> -->
          </template>
        </el-table-column>
      </el-table>
      <pagination v-show="total>0" :total="total" :pageNo.sync="query.pageNo" :pageSize.sync="query.pageSize" @pagination="doQueryList" />
    </el-card>
    <!-- 新建表单 -->
    <live-add ref="liveAdd" @created="doQueryList({})" />
    <live-goods-vue ref="liveGoods" @created="doQueryList({})" />
    <recharge-vue ref="recharge" @created="doQueryList({})" />
    <lucky-bag-vue ref="luckyBag" @created="doQueryList({})" />
    
    <!-- 管理员弹窗 -->
    <el-dialog title="管理员" :visible.sync="adminDialogVisible" width="600px" append-to-body>
      <div class="admin-header">
        <el-button type="primary" @click="handleAddAdmin" size="small" round>+ 添加管理员</el-button>
      </div>
      <el-table :data="adminList" style="width: 100%; margin-top: 20px;" v-loading="adminLoading">
        <el-table-column prop="avatar" label="头像" align="center" width="80">
          <template slot-scope="{row}">
            <el-image 
              v-if="row.avatar" 
              style="width: 40px; height: 40px; border-radius: 50%;" 
              :src="row.avatar" 
              fit="cover">
            </el-image>
            <div v-else style="width: 40px; height: 40px; border-radius: 50%; background-color: #f0f0f0; display: flex; align-items: center; justify-content: center;">
              <i class="el-icon-user" style="font-size: 20px; color: #999;"></i>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="realName" label="管理员姓名" align="center" />
        <el-table-column prop="position" label="管理员身份" align="center" />
        <el-table-column prop="userPhone" label="管理员手机号" align="center" />
        <el-table-column label="操作" align="center" width="100">
          <template slot-scope="{row}">
            <el-link type="primary" @click="handleRemoveAdmin(row)">移除</el-link>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import liveAdd from './add'
import liveManageApi from '@/api/live/liveManage'
import Pagination from '@/components/Pagination'
import liveGoodsVue from '../liveStreaming/add'
import rechargeVue from '../liveStreaming/recharge'
import luckyBagVue from '../liveStreaming/luckyBag'
export default {
  components: {
    Pagination,
    liveAdd,
    liveGoodsVue,
    rechargeVue,
    luckyBagVue
  },
  data() {
    return {
      list: [],
      total: 0,
      listLoading: true,
      query: {
        pageNo: 1,
        pageSize: 10,
      },
      selectItems: [],
      // 管理员弹窗相关
      adminDialogVisible: false,
      adminList: [],
      adminLoading: false,
      currentLiveRow: null
    }
  },
  created() {
    this.doQueryList({ pageNo: 1 })
  },
  methods: {
    handleExport() {
      this.$message && this.$message.info('导出功能开发中')
    },
    LiveTitleFormatter(row) {
      return `${row.livePO.id} - ${row.livePO.title}`
    },
    handleLuckyBag(row) {
      this.$refs.luckyBag.handleShow(row)
    },
    handleRecharge(row) {
      this.$refs.recharge.handleShow(row)
    },
    handleLiveGoods(row) {
      this.$refs.liveGoods.handleShow(row)
    },
    // 取消预告
    handleLiveCancel(row) {
      this.$common.confirm('是否确认取消预告？')
        .then(() => {
          return liveManageApi.updateLiveState({
            liveId: row.livePO.id,
            state: 4
          })
        })
        .then(() => {
          this.$common.showMsg('success', '取消预告成功')
          return this.doQueryList({ pageNo: 1 })
        })
        .catch(() => {
          this.$common.showMsg('error', '取消预告失败')
        })
    },
    copyStreamUrl(url) {
      if (navigator.clipboard && window.isSecureContext) {
        // 使用现代浏览器的 Clipboard API
        navigator.clipboard.writeText(url).then(() => {
          this.$message.success('复制成功')
        }).catch(() => {
          this.$message.error('复制失败')
        })
      } else {
        // 降级方案：使用传统的 document.execCommand
        const textArea = document.createElement('textarea')
        textArea.value = url
        textArea.style.position = 'fixed'
        textArea.style.left = '-999999px'
        textArea.style.top = '-999999px'
        document.body.appendChild(textArea)
        textArea.focus()
        textArea.select()
        try {
          document.execCommand('copy')
          this.$message.success('复制成功')
        } catch (err) {
          this.$message.error('复制失败')
        }
        document.body.removeChild(textArea)
      }
    },
    handleFilter() {
      this.query = {}
      this.doQueryList({ pageNo: 1, pageSize: 10 })
    },
    /**
     * 选择框变化
     */
    selectionChange(val) {
      this.selectItems = val
    },
    /**
     * 触发后端排序
     */
    sortChange({ prop, order }) {
      const sortKeyMap = {
        'createdTime': 'createdTimeSortSign',
        'operatedTime': 'operatedTimeSortSign'
      }
      for (var k in sortKeyMap) {
        const sortKey = sortKeyMap[k]
        if (k !== prop) {
          this.query[sortKey] = null
        } else {
          if (order === 'ascending') {
            this.query[sortKey] = 1
          } else {
            this.query[sortKey] = -1
          }
        }
      }
      this.doQueryList({})
    },
    /**
     * 触发搜索操作
     */
    handleQuery() {
      this.doQueryList({ pageNo: 1 })
    },
    /**
     * 执行列表查询
     */
    doQueryList({ pageNo, pageSize }) {
      if (pageNo) {
        this.query.pageNo = pageNo
      }
      if (pageSize) {
        this.query.pageSize = pageSize
      }
      this.query.state = 0
      this.listLoading = true
      return liveManageApi.fetchListLive(this.query)
        .then(data => {
          this.list = data.data.list
          this.total = data.data.total
        })
        .finally(() => {
          this.listLoading = false
        })
    },
    /**
     * 删除单条记录
     */
    handleDeleteSingle(row) {
      return this.$common.confirm('是否确认删除')
        .then(() => liveManageApi.deleteById(row.id))
        .then(() => {
          this.$common.showMsg('success', '删除成功')
          return this.doQueryList({ pageNo: 1 })
        })
    },
    /**
     * 批量删除记录
     */
    handleDeleteBatch() {
      if (this.selectItems.length <= 0) {
        this.$common.showMsg('warning', '请选择')
        return
      }
      return this.$common.confirm('是否确认删除')
        .then(() => liveManageApi.deleteBatch(this.selectItems.map(row => row.id)))
        .then(() => {
          this.$common.showMsg('success', '删除成功')
          return this.doQueryList({ pageNo: 1 })
        })
    },
    beforeHandleCommand(row, command) {
      return {
        'row': row,
        'command': command
      }
    },
    handleCommand(command) {
      if (this.selectItems.length <= 0) {
        this.$common.showMsg('warning', '请选择')
        return
      }
      let ids = this.selectItems.map(row => row.id)
      let txt = ""
      if (command.command === 1) {
        this.handleBatchState(ids, 1)
      } else if (command.command === 2) {
        this.handleBatchState(ids, 0)
      }
    },
    handleBatchState(ids, type) {
      let txt = type === 1 ? '确认将选中批量启用？' : '确认将选中批量禁用？'
      this.$common.confirm(txt).then(() => liveManageApi.setIsEnableBatch({ ids: ids, isEnable: type ? true : false }))
        .then(() => {
          this.$common.showMsg('success', '操作成功')
          return this.doQueryList({ pageNo: 1 })
        })
    },
    changeSwitch(row) {
      liveManageApi.setIsEnable({ id: row.id, isEnable: row.isEnable }).then(() => {
        this.$common.showMsg('success', '操作成功')
      })
    },
    /**
     * 打开新建表单
     */
    handleCreate(row) {
      this.$refs.liveAdd.handleCreate(row)
    },
    /**
     * 打开查看表单
     */
    handleShow(row) {
      this.$emit('handleShow', row, 2)
    },
    /**
     * 打开编辑表单
     */
    handleUpdate(row) {
      this.$refs.liveAdd.handleUpdate(row)
    },
    /**
     * 显示管理员列表
     */
    handleShowAdmins(row) {
      this.currentLiveRow = row
      this.adminList = row.livePO.liveAdminPOList || []
      this.adminDialogVisible = true
    },
    /**
     * 添加管理员
     */
    handleAddAdmin() {
      // TODO: 实现添加管理员功能
      this.$message.info('添加管理员功能待实现')
    },
    /**
     * 移除管理员
     */
    handleRemoveAdmin(admin) {
      this.$confirm('确认移除该管理员？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // TODO: 调用移除管理员接口
        this.$message.success('移除成功')
        // 刷新管理员列表
        this.refreshAdminList()
      }).catch(() => {
        this.$message.info('已取消')
      })
    },
    /**
     * 刷新管理员列表
     */
    refreshAdminList() {
      if (this.currentLiveRow) {
        // 重新获取直播详情来更新管理员列表
        liveManageApi.fetchListLive({ 
          ...this.query, 
          liveId: this.currentLiveRow.livePO.id 
        }).then(data => {
          const updatedRow = data.data.list.find(item => 
            item.livePO.id === this.currentLiveRow.livePO.id
          )
          if (updatedRow) {
            this.currentLiveRow = updatedRow
            this.adminList = updatedRow.livePO.liveAdminPOList || []
            // 更新主列表中的数据
            const index = this.list.findIndex(item => 
              item.livePO.id === this.currentLiveRow.livePO.id
            )
            if (index !== -1) {
              this.$set(this.list, index, updatedRow)
            }
          }
        })
      }
    }
  }
}
</script>
